import { USAGE_DEFINITION } from '@/misc/desktopCharts'
import { getDataByStartAndEndDate } from './lib/callChartAPI'

export default async (usageItem, storeId, startDate, endDate) => {
  let targetChartInfo = USAGE_DEFINITION.find(usage => usage.name === usageItem)
  const responses = await Promise.all([
    getDataByStartAndEndDate(targetChartInfo.rateChartName, startDate, endDate, storeId),
    getDataByStartAndEndDate(targetChartInfo.valueChartName, startDate, endDate, storeId)
  ])
  return {
    rateTotal: responses[0].total || 0.0,
    valueTotal: responses[1].total || 0,
    rateData: responses[0].data,
    valueData: responses[1].data
  }
}
